import React from "react";
import { ClipboardListIcon } from "@heroicons/react/solid";

const Resume = () => {
  return (
    <div
      id="Resume"
      className="lg:w-1/2 mt-64 mb-4 text-justify mx-12 lg:mr-60 lg:ml-auto"
    >
      <div>
        <div className="table">
          <ClipboardListIcon className="h-5 w-5 mr-4 text-water_vs" />{" "}
          <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
            Resume
          </code>
          <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
        </div>
      </div>
      <div className="text-[#a2aabc] text-lg mt-5">
        <div className="flex flex-row">
          <div className="w-1/4">
            <code className="text-yellow_vs">Education</code>
          </div>
          <div className="w-3/4">
            <code className="text-blue_vs">Graduation</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
              Bachelors in Electronics and Communication.
            </code>
            <br />
            <code className="text-xs text-brown_vs">
              • July 2018 - October 2022.
            </code>
          </div>
        </div>
        <div className="flex flex-row pt-10">
          <div className="w-1/4">
            <code className="text-red_vs">Work</code>
          </div>
          <div className="w-3/4">
            <code className="text-blue_vs">Intern</code>
            <br />
            <code className="italic text-sm text-lightblue_vs">
              SKITMG (Summer Internship), Jaipur.{" "}
            </code>
            <br />
            <code className="text-xs text-brown_vs">
              • May 2021 - July 2021.{" "}
            </code>
            <br />
            <code className="text-sm">
              <br />• Successfully translated user requirements into system
              functionalities for different projects like Bots, chat
              applications, APIs.
              <br />• Created solution patterns for the different projects.
              <br />• Object Oriented Programming.
              <br />• Python Programming Fundamentals.
              <br />• Used various Python Libraries.
              <br />• Deployed a Django app on AWS using Docker, Jenkins.CI-CD.
            </code>
          </div>
        </div>
        <div className="flex flex-row pt-10 flex-wrap">
          <div className="w-1/4">
            <code className="text-water_vs">Skills</code>
          </div>
          <div className="w-3/4">
            <code className="text-sm">
              <br />• <span className="text-red_vs font-bold">JavaScript</span>: A versatile programming language used for web development that allows dynamic and interactive elements on websites.
              <br />• <span className="text-yellow_vs font-bold">ReactJS:</span> A JavaScript library for building user interfaces that enables the creation of reusable UI components and facilitates the management of application state.
              <br />• <span className="text-water_vs font-bold">Next.js:</span> It provides features like automatic code splitting, server-side rendering, and easy routing.
              <br />• <span className="text-purple_vs font-bold">Tailwind CSS:</span> It focuses on customization and flexibility, allowing developers to rapidly build user interfaces.
              <br />•<span className="text-red_vs font-bold"> MongoDB:</span> A NoSQL database system that stores data in flexible, JSON-like documents. 
              <br />•<span className="text-yellow_vs font-bold">Python:</span> A versatile, high-level programming language known for its simplicity and readability. 
              <br />•<span className="text-water_vs font-bold"> Java:</span> A popular programming language known for its platform independence and object-oriented features. 
              <br />• <span className="text-purple_vs font-bold">Chakra UI:</span> A flexible and accessible component library for building user interfaces in React.
              <br />• <span className="text-red_vs font-bold">Framer Motion </span>: A library for creating fluid animations and transitions in React.
              <br />• <span className="text-yellow_vs font-bold">Linux</span>: An open-source operating system kernel that serves as the foundation for numerous Linux distributions.
              <br />• <span className="text-water_vs font-bold">Git/GitHub</span>: Git is a distributed version control system used for tracking changes in source code during software development. GitHub is a web-based platform that provides hosting for Git repositories and offers collaboration features for developers to work on projects together.
              <br />• <span className="text-purple_vs font-bold">SCSS</span>: SCSS (Sass CSS) is a preprocessor scripting language that extends the capabilities of CSS.
              
            </code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resume;
